import { Card } from "antd";

export default function TrustCenterCard({ children, style, bodyStyle }) {
  return (
    <Card
      style={{
        backgroundColor: "#fafafa",
        border: "1px solid #e8e8e8",
        borderRadius: "8px",
        height: "240px",
        display: "flex",
        flexDirection: "column",
        ...style,
      }}
      bodyStyle={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        flex: 1,
        padding: "20px",
        ...bodyStyle,
      }}
    >
      {children}
    </Card>
  );
}
